<div class="row box-container">
  <div class="col-sm-12" *ngIf="!isLeftSide">
    <div class="row item align-items-center" [ngClass]="{'large': isLarge}" *ngFor="let item of left; let i = index;">
      <div class="col-sm-1 index" *ngIf="showIndex">{{i + startIndex + 1}}.</div>
      <div class="col-sm-3 ellipsis mention">{{item.keyword}}</div>
      <div class="d-flex justify-content-end bar-container">
        <div class="progress-bar" [style.width.%]="(item.number/left[0].number)*100" [style.backgroundColor]="bgColor"></div>
      </div>
      <div class="d-flex justify-content-end number" *ngIf="!isFallbackView">{{item.number}}</div>
      <div class="d-flex justify-content-end number" *ngIf="isFallbackView">
        <div class="fallback-view-number-item"></div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 right-side" *ngIf="isLeftSide">
    <div class="row item align-items-center" [ngClass]="{'large': isLarge}" *ngFor="let item of right; let i = index;">
      <div class="col-sm-1 index" *ngIf="showIndex">{{i + startIndex + 1}}.</div>
      <div class="col-sm-3 ellipsis mention">{{item.keyword}}</div>
      <div class="d-flex justify-content-end bar-container">
        <div class="progress-bar" [ngClass]="{'large': isLarge}" [style.width.%]="(item.number/left[0].number)*100" [style.backgroundColor]="bgColor"></div>
      </div>
      <div class="d-flex justify-content-end number" *ngIf="!isFallbackView">{{item.number}}</div>
      <div class="d-flex justify-content-end number" *ngIf="isFallbackView">
        <div class="fallback-view-number-item"></div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-bar-chart-placeholder/achoo-bar-chart-placeholder.component.html